module.exports = __webpack_public_path__ + "img/bandera_peru.c43cd914.svg";